"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9.823 8.672h2.7c.912 0 1.654.741 1.654 1.653v3.35c0 .912-.742 1.653-1.653 1.653h-2.7V8.672z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10.524 4.886a3.21 3.21 0 003.21-3.21v-3.351a3.21 3.21 0 00-3.21-3.21H8.265v9.77h4.258z" })), "DLCs");
//# sourceMappingURL=DLC.js.map